<template>
    <v-ons-alert-dialog modifier="rowfooter" :visible.sync="visible" >
        <span slot="title" style="font-size: 18px;" >Подтвердить изменения?</span>

        <div style="margin-top: 5px;" >
            <v-ons-checkbox input-id="withNotyId" v-model="withNoty" style="vertical-align: middle;" ></v-ons-checkbox>
            <label for="withNotyId" style="font-weight: normal; vertical-align: middle; margin: 0" >Отправить уведомление</label>
        </div>

        <div :style="{
            marginTop: '5px',
            maxHeight: ($window.height - 240) + 'px',
            overflowY: 'auto'
            }">
            <div v-for="(standartReason, index) in standartReasons">
                <v-ons-checkbox
                    style="margin: 5px 5px 0 5px; vertical-align: middle;"
                    v-model="checkedStandartReasons"
                    :input-id="'standartReason-' + index"
                    :value="index"
                    :disabled="!withNoty"
                />
                <label
                    :for="'standartReason-' + index"
                    style="font-weight: normal; vertical-align: middle; margin: 0"
                >{{ standartReason }}</label>
            </div>
        </div>

        <div style="margin-top: 10px" >
            <textarea :disabled="!withNoty" v-model="reason" class="textarea" placeholder="Укажите причину" rows="4" style="width: 100%;" ></textarea>
        </div>

        <template slot="footer">
            <v-ons-alert-dialog-button @click="ok">ОК</v-ons-alert-dialog-button>
            <v-ons-alert-dialog-button @click="cancel">Отмена</v-ons-alert-dialog-button>
        </template>
    </v-ons-alert-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            withNoty: true,
            reason: '',

            checkedStandartReasons: [],
            standartReasons: [
                'Добавка',
                'Корректировка',
                'Уточнение веса при наборе',
                'Вычерки при наборе',
                'Изменение адреса',
                'Изменение даты',
                'Изменение способа оплаты',
            ],

            resolve: null,
            reject: null,
        }
    },
    methods: {
        confirm() {
            this.visible = true;
            this.withNoty = this.$user.isConfirmEmailSendingEnabled;
            this.reason = '';
            this.checkedStandartReasons = [];

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        cancel() {
            this.visible = false;
            this.reject('break');
        },
        ok() {
            this.visible = false;
            let reasons = [];

            if (this.checkedStandartReasons.length > 0) {
                reasons = this.standartReasons
                    .filter((val, index) => {
                        return this.checkedStandartReasons.includes(index.toString());
                    });
            }

            if (this.reason.trim()) {
                reasons.push(this.reason.trim());
            }

            let reason = reasons.join('. ');

            this.resolve({withNoty: this.withNoty, reason: reason});
        },
    },
};
</script>
